import { useQuery } from '@tanstack/react-query';
import { parseChangelogFeed, type ChangelogEntryDto } from '@nexops/shared';

/** Wydane wpisy CHANGELOG.md opublikowane razem z panelem (`/changelog.json`, bez cache). */
export function useChangelog(enabled = true) {
  return useQuery({
    queryKey: ['app-changelog'],
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
    meta: { silent: true },
    queryFn: async (): Promise<ChangelogEntryDto[]> => {
      const res = await fetch(`${import.meta.env.BASE_URL}changelog.json?t=${Date.now()}`, { cache: 'no-store', credentials: 'omit' });
      if (!res.ok) return [];
      return parseChangelogFeed(await res.json());
    },
  });
}
